import React from "react";
import Modal from "./Modal";
import type { ConfirmModalProps } from "./ConfirmModal.types";

const confirmVariantClasses: Record<NonNullable<ConfirmModalProps["confirmVariant"]>, { base: string; hover: string; ring: string }> = {
    primary: { base: "bg-green-600", hover: "hover:bg-green-700", ring: "focus:ring-green-500" },
    danger: { base: "bg-red-600", hover: "hover:bg-red-700", ring: "focus:ring-red-500" },
};

const ConfirmModal: React.FC<ConfirmModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        message,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        confirmDisabled = false,
        confirmVariant = "primary",
    }) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const variant = confirmVariantClasses[confirmVariant];

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            size="md"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={confirmDisabled}
                        className={`inline-flex items-center rounded-full ${variant.base} px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 ${variant.ring} ${confirmDisabled ? "opacity-50 cursor-not-allowed" : `cursor-pointer ${variant.hover}`}`}
                    >
                        {confirmLabel}
                    </button>
                </>
            }
        >
            <p className="text-gray-700">{message}</p>
        </Modal>
    );
};

export default ConfirmModal;
